export default __webpack_public_path__ + "static/media/notice_inform_blue.891f5871.svg";